/** Look of every panel over the map. White (strong border) is the default. */
export const PANEL_THEMES = ["white", "dark", "glass"] as const;
export type PanelTheme = (typeof PANEL_THEMES)[number];
export const DEFAULT_PANEL_THEME: PanelTheme = "white";
export const PANEL_THEME_KEY = "mapus.panelTheme";

export interface ThemeStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function isPanelTheme(value: unknown): value is PanelTheme {
  return typeof value === "string" && (PANEL_THEMES as readonly string[]).includes(value);
}

export function readPanelTheme(store: ThemeStore | null | undefined): PanelTheme {
  try {
    const raw = store?.getItem(PANEL_THEME_KEY);
    return isPanelTheme(raw) ? raw : DEFAULT_PANEL_THEME;
  } catch {
    return DEFAULT_PANEL_THEME;
  }
}

export function writePanelTheme(store: ThemeStore | null | undefined, theme: PanelTheme): void {
  try {
    store?.setItem(PANEL_THEME_KEY, theme);
  } catch {
    /* private mode */
  }
}

/** Sets `data-theme` on the root element. The CSS variables follow it. */
export function applyPanelTheme(root: { dataset: Record<string, string | undefined> }, theme: PanelTheme): void {
  root.dataset.theme = theme;
}

/** 0..1 position of a range value, for the filled part of the track. */
export function rangeFraction(value: number, min: number, max: number): number {
  if (!Number.isFinite(value) || !Number.isFinite(min) || !Number.isFinite(max) || max <= min) return 0;
  return Math.min(1, Math.max(0, (value - min) / (max - min)));
}
